import moment from 'moment-timezone'
import DateFormatter from '@/classes/DateFormatter'

export default class TimeService {

  public static diff(startedAt: string | null, completedAt: string | null) {

    const m = moment.tz.setDefault(DateFormatter.MAIN_TIMEZONE)

    if (completedAt && completedAt.length && startedAt && startedAt.length) {
      return m(completedAt).diff(m(startedAt), 'seconds')
    }
    if ((!completedAt || !completedAt.length) && startedAt && startedAt.length) {
      return m().diff(m(startedAt), 'seconds')
    }
    return 0
  }
}
